import { useState } from "react";
import { Star } from "lucide-react";

export const Stars = ({ value, size = 16, testid }) => (
  <div className="flex items-center gap-0.5" data-testid={testid} aria-label={`${value} din 5 stele`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={size}
        className={i <= Math.round(value) ? "fill-[#FFB800] text-[#FFB800]" : "text-slate-600"}
      />
    ))}
  </div>
);

const LABELS = ["", "Slab", "Acceptabil", "Bine", "Foarte bine", "Excelent"];

export const StarPicker = ({ value, onChange }) => {
  const [hover, setHover] = useState(0);
  const shown = hover || value;
  return (
    <div data-testid="star-rating-selector">
      <div className="flex gap-2" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((i) => (
          <button
            key={i}
            type="button"
            data-testid={`star-btn-${i}`}
            onMouseEnter={() => setHover(i)}
            onClick={() => onChange(i)}
            className="p-1 transition-transform duration-150 hover:scale-110 active:scale-95"
            aria-label={`${i} stele`}
          >
            <Star size={36} className={i <= shown ? "fill-[#FFB800] text-[#FFB800]" : "text-slate-600"} />
          </button>
        ))}
      </div>
      <p className="mt-1 h-5 text-sm text-slate-400" data-testid="star-rating-label">{LABELS[shown]}</p>
    </div>
  );
};
